<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">
            {{ $route.meta.title }}
          </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons">
            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="saveReseller()"
              class="min-button"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="customer.url_picture"
                          v-bind:style="{
                            backgroundImage: 'url(' + customer.url_picture + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="mb-4 ">
                      <el-input
                        v-model="$v.customer.notes.$model"
                        placeholder="Special Requirements"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            type="primary"
          >
            <tab-pane
              class="tabs-home-content"
              id="Overview"
              title="Overview"
              ref="Overview"
            >
              <div class="card">
                <h2 class="subtitle">
                  Business Details
                </h2>

                <div class="row mt-2">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-capitalize
                          v-model.trim="$v.customer.company_name.$model"
                          label="Business Name"
                          placeholder="Business Name"
                          id="bussiness_name"
                          name="bussiness_name"
                          tabindex="1"
                          maxlength="45"
                          markrequired
                          :error="validateCompanyName($v.customer.company_name)"
                        />
                      </div>

                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-capitalize
                          v-model.trim="$v.customer.legal_name.$model"
                          label="Legal Name"
                          placeholder="Legal Name"
                          id="bussiness_Legalname"
                          name="bussiness_Legalname"
                          tabindex="2"
                          maxlength="45"
                          :error="validateLegalName($v.customer.legal_name)"
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.iata_code.$model"
                          label="IATA Code"
                          placeholder="IATA Code"
                          id="bussiness_iata_code"
                          name="bussiness_iata_code"
                          tabindex="2"
                          maxlength="45"
                          :error="validateIataCode($v.customer.iata_code)"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.vat_number.$model"
                          label="VAT Number"
                          placeholder="VAT Number"
                          id="bussiness_VatNumber"
                          name="bussiness_VatNumber"
                          tabindex="2"
                          maxlength="45"
                          :error="validateVatNumber($v.customer.vat_number)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card  ">
                <h2 class="subtitle">Main Contact</h2>
                <div class="row">
                  <div class="col-xl-12 mt-2">
                    <div class="row">
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-capitalize
                          v-model.trim="$v.customer.first_name.$model"
                          label="First Name"
                          placeholder="First Name"
                          id="first_name"
                          name="first_name"
                          maxlength="45"
                          tabindex="1"
                          markrequired
                          :error="validateFirstName($v.customer.first_name)"
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-capitalize
                          v-model.trim="$v.customer.last_name.$model"
                          label="Last Name"
                          placeholder="Last Name"
                          id="last_name"
                          name="last_name"
                          maxlength="45"
                          tabindex="2"
                          markrequired
                          :error="validateLastName($v.customer.last_name)"
                        />
                      </div>
                      <div
                        class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 form-group"
                        v-bind:class="{
                          'is-invalid': $v.customer.gender.$error
                        }"
                      >
                        <label for="title" class="title-label">Gender</label>
                        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                          <b-form-radio-group
                            v-model="$v.customer.gender.$model"
                            :aria-describedby="ariaDescribedby"
                            id="radio-gender"
                            name="radio-gender"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                            tabindex="3"
                          >
                            <b-form-radio value="male" class="pc-4" tabindex="3"
                              >Mr.</b-form-radio
                            >
                            <b-form-radio value="female" class="pc-4"
                              >Mrs.</b-form-radio
                            >
                            <b-form-radio value="other" class="pc-4"
                              >Mx.</b-form-radio
                            >
                          </b-form-radio-group>
                        </b-form-group>

                        <small
                          class="invalid-feedback mt-1"
                          v-if="$v.customer.gender.$error"
                          >Select</small
                        >
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
                      >
                        <label
                          class="title-label"
                          v-bind:class="{
                            'is-invalid': $v.customer.phone.$error
                          }"
                          ><span class="markrequired">*</span>Contact
                          Number</label
                        >
                        <vue-tel-input
                          v-model="phoneFormat"
                          key="NumberPhoneCustomer"
                          inputId="NumberPhoneCustomer"
                          name="NumberPhoneCustomer"
                          required
                          mode="international"
                          inputClasses="input no-label no-err"
                          :dynamicPlaceholder="true"
                          :disabledFetchingCountry="true"
                          :validCharactersOnly="true"
                          :wrapperClasses="[
                            $v.customer.phone.$error ? 'is-invalid' : '',
                            'mb-0'
                          ]"
                          @validate="phoneInput"
                          tabindex="6"
                        ></vue-tel-input>
                        <small
                          class="invalid-feedback mt-1"
                          v-if="$v.customer.phone.$error"
                          >Enter a valid Phone Number</small
                        >
                      </div>

                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                        <label class="title-label">Other Contact Info</label>
                        <div class="d-flex">
                          <b-form-group
                            v-slot="{ ariaDescribedby2 }"
                            class="d-inline-flex"
                          >
                            <b-form-radio-group
                              v-model="customer.other_contact_platform"
                              :aria-describedby="ariaDescribedby2"
                              id="radio-contact"
                              name="radio-contact"
                              tabindex="7"
                              buttons
                              button-variant="outline-neutral"
                              size="md"
                            >
                              <b-form-radio
                                value="Whatsapp"
                                class="pc-2"
                                title="Whatsapp"
                                tabindex="7"
                                ><i class="flaticon-bold-whatsapp f16"></i
                              ></b-form-radio>
                              <b-form-radio
                                value="Skype"
                                class="pc-2"
                                title="Skype"
                                ><i
                                  class="flaticon-bold-logotipo-de-skype f16"
                                ></i
                              ></b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>

                          <base-input
                            v-model.trim="customer.contact_info"
                            placeholder="Other Contact Info"
                            id="passengers_phone_optional"
                            name="passengers_phone_optional"
                            tabindex="8"
                            class="d-inline-flex"
                          >
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card  ">
                <h2 class="subtitle">Account Info</h2>

                <div class="row mt-2">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                        <base-input
                          label="Email Address"
                          placeholder="Email Address"
                          id="customer_email"
                          name="customer_email"
                          maxlength="100"
                          tabindex="14"
                          format="lowercase"
                          autocomplete="off"
                          markrequired
                          v-model="$v.customer.email.$model"
                          :error="validateEmailField($v.customer.email)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card ">
                <h2 class="subtitle">Address</h2>

                <div class="row mt-2">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-capitalize
                      v-model="$v.customer.street.$model"
                      label="Street address, apartment, suite, etc."
                      placeholder="Street address, apartment, suite, etc"
                      id="customer_street"
                      name="customer_street"
                      maxlength="200"
                      tabindex="9"
                      :error="validateStreet($v.customer.street)"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-capitalize
                      v-model="$v.customer.city.$model"
                      label="City"
                      placeholder="City"
                      id="customer_city"
                      name="customer_city"
                      maxlength="45"
                      tabindex="10"
                      :error="validateCity($v.customer.city)"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-capitalize
                      v-model="$v.customer.state.$model"
                      label="State/Province/Region"
                      placeholder="State/Province/Region"
                      id="customer_state"
                      name="customer_state"
                      maxlength="45"
                      tabindex="11"
                      :error="validateState($v.customer.state)"
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model.trim="$v.customer.zip_code.$model"
                      label="Zip/Postal Code"
                      placeholder="Zip/Postal Code"
                      id="customer_zipcode"
                      name="customer_zipcode"
                      maxlength="45"
                      tabindex="12"
                      :error="validateZipCode($v.customer.zip_code)"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'invalid-feedback': $v.customer.country.$error
                      }"
                      v-model="$v.customer.country.$model"
                      label="Country"
                      placeholder="Enter a Country"
                      id="customer_country"
                      name="customer_country"
                      tabindex="13"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="searchCountry"
                      :loading="loading"
                      clearable
                    >
                      <el-option
                        v-for="country in countriesOptions"
                        :value="country.name"
                        :label="country.name"
                        :key="country.name"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="paymentInfo"
              title="Payment Info"
              ref="paymentInfo"
            >
              <div class="card">
                <div class="row mt-2 align-items-center">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.mark_up.$model"
                      label="Markup"
                      placeholder="Markup"
                      id="customer_markup"
                      name="customer_markup"
                      maxlength="3"
                      tabindex="17"
                      class="input-append"
                      markrequired
                      @input="validateMarkup"
                      :error="validateMarkupField($v.customer.mark_up)"
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.commission.$model"
                      label="Commission"
                      placeholder="Commission"
                      id="commission"
                      name="commission"
                      maxlength="3"
                      class="input-append"
                      tabindex="19"
                      markrequired
                      :error="validateCommission($v.customer.commission)"
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  decimal,
  between,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { ResellersAPI, AuthAPI } from "../../../core/api";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import { cloneDeep, isEqual } from "lodash";
import Swal from "sweetalert2";
import { goBack, isUserAuthorized } from "../../../helpers/commons.helpers";
import { FileService } from "../../../core/services";
import {
  validateCompanyName,
  validateLegalName,
  validateIataCode,
  validateVatNumber,
  validateFirstName,
  validateLastName,
  validateEmailField,
  validateStreet,
  validateCity,
  validateState,
  validateZipCode,
  validateMarkupField,
  validateCommission
} from "../services/validation.resellers";

export default {
  name: "NewReseller",
  data() {
    return {
      customer: {
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        phone: "",
        type: "ota",
        company_name: "",
        legal_name: "",
        iata_code: "",
        vat_number: "",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        notes: "",
        mark_up: 32,
        type_markup: "markup",
        type_charge: "commission",
        commission: 10,
        gender: "other",
        contact_info: "",
        other_contact_platform: "",
        currency: {
          code: "USD",
          symbol: "$",
          label: "US Dollar"
        },
        source: "rhomtrip",
        url_picture: ""
      },
      loading: false,
      countriesOptions: [],
      saved: false,
      customerCopy: {},
      picture: "",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      tabActive: "",
      phoneFormat: ""
    };
  },
  async created() {
    this.customerCopy = cloneDeep(this.customer);
    this.countriesOptions = this.countries;
  },
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Resellers",
        to: "/resellers"
      },
      {
        text: "New Reseller",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    async readFile(event) {
      const [file] = event.target.files;
      if (!file) return;

      const MAX_SIZE = 2 * 1024 * 1024;
      if (file.size > MAX_SIZE) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The image cannot exceed 2MB",
          icon: "flaticon-remove"
        });
        event.target.value = "";
        return;
      }

      try {
        const fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        const queryString = FileService.buildQueryString(fileData);
        const urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.customer.url_picture = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The image could not be uploaded. Please try again.",
            icon: "flaticon-remove"
          });
          event.target.value = "";
        }
      } catch {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The image could not be uploaded. Please try again.",
          icon: "flaticon-remove"
        });
        event.target.value = "";
      }
    },
    clearfile() {
      this.customer.url_picture = "";
      this.picture = "";
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.countriesOptions = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.countriesOptions = [];
      }
    },
    phoneInput(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      } else {
        this.customer.phone = "";
      }
    },
    validateMarkup(value) {
      if (parseFloat(value) < 0) {
        this.customer.mark_up = 0;
      }
    },
    async createReseller(reseller, router) {
      try {
        this.setLoad(true);
        let { data } = await ResellersAPI.createReseller(
          reseller,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reseller has been Saved",
            icon: "flaticon-check-3"
          });
          console.log(data);
          this.$router.push(router ? router : `/resellers/${data._id}`);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Reseller, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.saved = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Reseller, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async saveReseller(router = null) {
      if (!this.$v.customer.$invalid) {
        let reseller = cloneDeep(this.customer);
        reseller.full_name = `${reseller.first_name} ${reseller.last_name}`;
        reseller.email = reseller.email.toLowerCase();
        await this.createReseller(reseller, router);
      } else {
        this.$v.customer.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async verifyEmailCustomer(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          }
        }
        return false;
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    isInResellersModule(modules = []) {
      if (!modules.includes("RESELLERS")) {
        this.setResellerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(from, to, next) {
      const hasChanges = !isEqual(this.customer, this.customerCopy);
      if (hasChanges && !this.saved && this.canUserCreate) {
        const { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Reseller has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveReseller(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    validateCompanyName,
    validateLegalName,
    validateIataCode,
    validateVatNumber,
    validateFirstName,
    validateLastName,
    validateEmailField,
    validateStreet,
    validateCity,
    validateState,
    validateZipCode,
    validateMarkupField,
    validateCommission,
    ...mapMutations(["setLoad", "setItemsBread", "setResellerSearchCriteria"])
  },
  computed: {
    ...mapGetters(["countries", "sesion", "userRole"]),
    canUserCreate() {
      return isUserAuthorized("RESELLERS", this.userRole, "CREATE");
    }
  },
  validations: {
    customer: {
      first_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      last_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      company_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      legal_name: {
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      iata_code: {
        minLength: minLength(5),
        maxLength: maxLength(25)
      },
      vat_number: {
        minLength: minLength(5),
        maxLength: maxLength(25)
      },
      mark_up: {
        numeric,
        decimal,
        between: between(0, 100)
      },
      email: {
        required,
        email,
        customValidator: async function(value) {
          if (this.validateEmail(value)) {
            return await this.verifyEmailCustomer(value);
          }
          return false;
        }
      },
      gender: {
        required
      },
      phone: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(25)
      },
      country: {
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      city: {
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      state: {
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      zip_code: {
        minLength: minLength(4),
        maxLength: maxLength(10)
      },
      street: {
        minLength: minLength(5),
        maxLength: maxLength(100)
      },
      notes: {
        maxLength: maxLength(200)
      },
      commission: {
        numeric,
        decimal,
        between: between(0, 100)
      }
    }
  },
  components: {
    VueTelInput,
    WSelect
  },
  beforeRouteLeave(to, from, next) {
    this.isInResellersModule(to.meta.modules);
    this.detectChanges(from, to, next);
  }
};
</script>
